import { AbconetApi } from '../General/AbconetApi';
import $ from "jquery";

export class ReportScheduleListing extends React.Component {

    constructor(props) {
        super(props); 
        this.filterableResult = React.createRef();
        this.state = {
            markedForDeletion: {},
            isDeleting: {},
            scheduleListing: null
        }; 
    }

    loadReportSchedule() {
        if (!this.props.isTemplateScheduleListing) {
            AbconetApi.get(`/api/report/scheduleListing`).then((scheduleListing) => {
                this.setState({ scheduleListing: scheduleListing });
            });

            $(document).on('ReportScheduleAdded', this.loadReportSchedule.bind(this));
        }
    }

    componentDidMount() {
        this.loadReportSchedule();
    }


    unsubscribeSchedule(id) {
        var markedForDeletion = this.state.markedForDeletion;
        markedForDeletion[id] = true;

        this.setState({ markedForDeletion: markedForDeletion });
    }

    removePendingDelete(id) {
        var markedForDeletion = this.state.markedForDeletion;
        markedForDeletion[id] = false;

        this.setState({ markedForDeletion: markedForDeletion });
    }

    confirmDelete(id) {
        var isDeleting = this.state.isDeleting;
        isDeleting[id] = true;

        this.setState({ isDeleting: isDeleting });

        if (this.props.isTemplateScheduleListing) {
            AbconetApi
                .delete('/api/address/' + this.props.siteId + '/templateschedule?scheduleId=' + id)
                .then(() => {

                    this.props.updateTemplateScheduleList();
                });
        } else {
            AbconetApi
                .delete('/api/report/' + id + '/delete')
                .then(() => {
                    this.componentDidMount();
                });
        }
        
    }

    renderDeleteHover(row) {
        var message = "Do you want to unsubscribe from " + row.reportName + "?";
        var confirmation = "Yes, unsubscribe";

        if (this.props.isTemplateScheduleListing) {
            message = "Do you want to delete " + row.templateName + ", " + row.cronDescription + " schedule?";
            confirmation = "Yes, delete schedule";
        }

        if (this.state.markedForDeletion[row.id]) {
            var isDeleting = this.state.isDeleting[row.id];
            var buttonClassName = "btn btn-danger";
            if (isDeleting) {
                buttonClassName = "btn btn-danger saving";
            }

            return (
                <div className="delete-confirm">
                    <div className="row">
                        <div className="col-12">
                            <div className="message">{message}</div>
                            <div className="btn-group" role="group" aria-label="Basic example">
                                <button type="button" className="btn btn-outline-primary" onClick={this.removePendingDelete.bind(this, row.id)} disabled={isDeleting}>No, Keep Schedule</button>
                                <button type="button" className={buttonClassName} onClick={this.confirmDelete.bind(this, row.id)} disabled={isDeleting}>{confirmation}</button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }


    renderRows(row) {

        var reportLabel = row.reportName + '-' + row.period;
        if (row.reportName == 'Backorders') {
            reportLabel = row.reportName;
        }

        if (this.props.isTemplateScheduleListing) {
            reportLabel = <a href={`/templates/${row.templateId}/`}>{row.templateName}</a>
        }

        var unsubscribeButton = <span href="#" className="delete-button" onClick={(ev) => this.unsubscribeSchedule(row.id)}><i className="icon icon-trash px-3 lead"></i></span>;

        if (this.props.isTemplateScheduleListing && !this.props.canEdit && !this.props.canCreateRecurringOrders) {
            unsubscribeButton = "";
        }

        return (
            <div className="item" key={row.id}>
                {this.renderDeleteHover(row)}
                <div className="row">
                    <div className="col-6"> {reportLabel} </div>
                    <div className="col-3"> {row.cronDescription} </div>
                    <div className="col-3 text-center">
                        {unsubscribeButton}
                    </div>
                </div>
            </div>
        );
    }

    renderReportHeader() {
        var name = "Report Name";
        if (this.props.isTemplateScheduleListing) {
            name = "Template Name";
        }

        return <div className="row header">
            <div className="col-6 col-hd">
                {name}
            </div>
            <div className="col-3 col-hd">
                Schedule
            </div>
            <div className="col-3">
            </div>
        </div>;
    }

    renderData(resultCollection) {
        if (resultCollection != null && resultCollection.length <= 0) {
            return <div></div>;
        }

        return (
            <div className="list-group">
                {this.renderReportHeader()}

                {resultCollection.map(this.renderRows.bind(this))}
            </div>
        );
    }

    render() {
        var scheduleListing = null;

        if (this.state.scheduleListing != null && this.state.scheduleListing.list != null) {
            scheduleListing = this.state.scheduleListing.list;
        } else if (this.props.isTemplateScheduleListing) {
            scheduleListing = this.props.templateScheduleListing;
        }

        if (scheduleListing == null) {
            return null;
        }

        return (
            <div className="row pt-5">
                <div className="col-12">
                    {this.renderData(scheduleListing)}
                </div>
            </div>
        );
    }

}